/**
 * @description Gestion de la navigation clavier des suggestions de recherches
 */

(() => {
	const keyBoardNavAutocomplete = () => {
		const autocomplete =
			document.querySelector('.form-autocomplete') || null;

		if (autocomplete) {
			autocomplete.addEventListener(
				'keydown',
				(e) => {
					setTimeout(() => {
						if (e.key === 'Tab') {
							const suggestions = document.querySelector(
								'.search-api-autocomplete-search'
							);

							suggestions.style.display = 'block';
							suggestions
								.querySelectorAll('li')
								.forEach((item) => {
									const link = item.firstElementChild;
									link.tabIndex = 0;
									e.preventDefault();

									if (
										item === suggestions.firstElementChild
									) {
										link.focus();
									}
								});

							suggestions.addEventListener('keydown', (e) => {
								if (e.key === 'Tab') {
									if (
										document.activeElement.parentNode ===
										suggestions.lastElementChild
									) {
										const inputSearch =
											document.querySelector(
												'#edit-submit-main-search-engine'
											);
										e.preventDefault();
										inputSearch.focus();
										suggestions.style.display = 'none';
									}
								}

								if (e.key === 'Enter') {
									document.activeElement.click();
								}
							});
						}
					});
				},
				500
			);
		}
	};
	// GO 🚀
	const init = () => {
		keyBoardNavAutocomplete();
	};

	init();
})();
